import React from "react";

/* ═══ Real brand glyphs for known desktop apps ═══════════════════════════
   Hand-drawn flat SVGs (no gradients — gradient ids collide across <use>
   instances), viewBox 0 0 100 100, ~0.3-0.8KB each. Apps NOT in this map
   fall back to ToolIcon's existing brand-coloured monogram tile, so an
   unknown name can never break — it just looks like today.
   Matching is substring-based (same contract as BRAND in panels.jsx),
   most-specific key first. */

const ICONS = {
  chrome: (
    <>
      <circle cx="50" cy="50" r="48" fill="#fff" />
      <path d="M50 50 L91.57 26 A48 48 0 0 0 8.43 26 Z" fill="#EA4335" />
      <path d="M50 50 L8.43 26 A48 48 0 0 0 50 98 Z" fill="#34A853" />
      <path d="M50 50 L50 98 A48 48 0 0 0 91.57 26 Z" fill="#FBBC05" />
      <circle cx="50" cy="50" r="26" fill="#fff" />
      <circle cx="50" cy="50" r="19" fill="#4285F4" />
    </>
  ),
  edge: (
    <>
      <circle cx="50" cy="50" r="48" fill="#1B8DE0" />
      <path d="M14 66c-2-26 16-44 38-44 20 0 34 13 34 29 0 11-7 17-17 17H45c1 9 10 15 22 15 6 0 12-1 17-4-6 13-19 21-34 21-19 0-34-14-36-34z" fill="#35D6C9" opacity="0.95" />
      <path d="M45 68c-1-14 8-24 21-24 9 0 16 5 18 12 1 6-2 8-8 8H45z" fill="#0A50A8" />
    </>
  ),
  safari: (
    <>
      <circle cx="50" cy="50" r="48" fill="#F2F2F5" />
      <circle cx="50" cy="50" r="42" fill="#1E9BF6" />
      <path d="M70 30 L56 56 L44 44 Z" fill="#FF4B4B" />
      <path d="M30 70 L44 44 L56 56 Z" fill="#FFFFFF" />
    </>
  ),
  claude: (
    <>
      <rect width="100" height="100" rx="24" fill="#F4EEE6" />
      <g stroke="#D97757" strokeWidth="9" strokeLinecap="round">
        <line x1="50" y1="50" x2="50" y2="16" />
        <line x1="50" y1="50" x2="67" y2="21" />
        <line x1="50" y1="50" x2="79" y2="34" />
        <line x1="50" y1="50" x2="84" y2="52" />
        <line x1="50" y1="50" x2="76" y2="70" />
        <line x1="50" y1="50" x2="61" y2="82" />
        <line x1="50" y1="50" x2="42" y2="84" />
        <line x1="50" y1="50" x2="26" y2="76" />
        <line x1="50" y1="50" x2="17" y2="60" />
        <line x1="50" y1="50" x2="17" y2="41" />
        <line x1="50" y1="50" x2="27" y2="25" />
      </g>
    </>
  ),
  slack: (
    <>
      <rect x="31" y="8" width="15" height="38" rx="7.5" fill="#36C5F0" />
      <rect x="31" y="8" width="15" height="38" rx="7.5" fill="#2EB67D" transform="rotate(90 50 50)" />
      <rect x="31" y="8" width="15" height="38" rx="7.5" fill="#ECB22E" transform="rotate(180 50 50)" />
      <rect x="31" y="8" width="15" height="38" rx="7.5" fill="#E01E5A" transform="rotate(270 50 50)" />
    </>
  ),
  cmd: (
    <>
      <rect width="100" height="100" rx="22" fill="#1F1F1F" />
      <path d="M24 32l20 18-20 18" stroke="#fff" strokeWidth="9" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="52" y1="70" x2="76" y2="70" stroke="#fff" strokeWidth="9" strokeLinecap="round" />
    </>
  ),
  powershell: (
    <>
      <rect width="100" height="100" rx="22" fill="#2671BE" />
      <path d="M24 32l20 18-20 18" stroke="#fff" strokeWidth="9" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="52" y1="70" x2="76" y2="70" stroke="#fff" strokeWidth="9" strokeLinecap="round" />
    </>
  ),
  terminal: (
    <>
      <rect width="100" height="100" rx="22" fill="#28313C" />
      <circle cx="20" cy="18" r="4.5" fill="#FF5F57" />
      <circle cx="34" cy="18" r="4.5" fill="#FEBC2E" />
      <circle cx="48" cy="18" r="4.5" fill="#28C840" />
      <path d="M26 42l14 13-14 13" stroke="#fff" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="48" y1="68" x2="70" y2="68" stroke="#fff" strokeWidth="8" strokeLinecap="round" />
    </>
  ),
  notepad: (
    <>
      <rect x="14" y="12" width="72" height="80" rx="10" fill="#fff" stroke="#B9C8DE" strokeWidth="3" />
      <path d="M14 30v-8c0-5.5 4.5-10 10-10h52c5.5 0 10 4.5 10 10v8H14z" fill="#2F7FE0" />
      <circle cx="30" cy="21" r="3" fill="#fff" opacity="0.85" />
      <circle cx="44" cy="21" r="3" fill="#fff" opacity="0.85" />
      <circle cx="58" cy="21" r="3" fill="#fff" opacity="0.85" />
      <line x1="26" y1="46" x2="74" y2="46" stroke="#C7D3E4" strokeWidth="5" strokeLinecap="round" />
      <line x1="26" y1="60" x2="74" y2="60" stroke="#C7D3E4" strokeWidth="5" strokeLinecap="round" />
      <line x1="26" y1="74" x2="58" y2="74" stroke="#C7D3E4" strokeWidth="5" strokeLinecap="round" />
    </>
  ),
  notes: (
    <>
      <rect x="10" y="10" width="80" height="80" rx="18" fill="#fff" stroke="#E3E3E8" strokeWidth="2" />
      <path d="M10 28c0-10 8-18 18-18h44c10 0 18 8 18 18H10z" fill="#F7C64B" />
      <line x1="24" y1="46" x2="76" y2="46" stroke="#D8D8DE" strokeWidth="5" strokeLinecap="round" />
      <line x1="24" y1="60" x2="76" y2="60" stroke="#D8D8DE" strokeWidth="5" strokeLinecap="round" />
      <line x1="24" y1="74" x2="60" y2="74" stroke="#D8D8DE" strokeWidth="5" strokeLinecap="round" />
    </>
  ),
  vscode: (
    <>
      <rect width="100" height="100" rx="22" fill="#0D6EB8" />
      <path d="M68 16L34 48 22 39l-8 6 14 10-14 10 8 6 12-9 34 32 14-7V23l-14-7zM66 36v28L46 50l20-14z" fill="#fff" />
    </>
  ),
  cursor: (
    <>
      <rect width="100" height="100" rx="22" fill="#101010" />
      <g stroke="#fff" strokeWidth="5.5" fill="none" strokeLinejoin="round" strokeLinecap="round">
        <polygon points="50,18 77,34 77,66 50,82 23,66 23,34" />
        <path d="M23 34 L50 50 L77 34 M50 50 V82" />
      </g>
    </>
  ),
  excel: (
    <>
      <rect width="100" height="100" rx="22" fill="#217346" />
      <line x1="32" y1="32" x2="68" y2="68" stroke="#fff" strokeWidth="13" strokeLinecap="round" />
      <line x1="68" y1="32" x2="32" y2="68" stroke="#fff" strokeWidth="13" strokeLinecap="round" />
    </>
  ),
  word: (
    <>
      <rect width="100" height="100" rx="22" fill="#2B579A" />
      <polyline points="26,32 36,68 50,42 64,68 74,32" stroke="#fff" strokeWidth="8.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  powerpoint: (
    <>
      <rect width="100" height="100" rx="22" fill="#C43E1C" />
      <path d="M38 72 V28 H55 a13 13 0 0 1 0 26 H38" fill="none" stroke="#fff" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  outlook: (
    <>
      <rect width="100" height="100" rx="22" fill="#0F6CBD" />
      <circle cx="50" cy="50" r="17" fill="none" stroke="#fff" strokeWidth="10" />
    </>
  ),
  gmail: (
    <>
      <rect width="100" height="100" rx="22" fill="#fff" stroke="#E6E6E6" strokeWidth="2" />
      <rect x="14" y="28" width="12" height="44" rx="6" fill="#4285F4" />
      <rect x="74" y="28" width="12" height="44" rx="6" fill="#34A853" />
      <path d="M20 32 L50 56 L80 32" stroke="#EA4335" strokeWidth="11" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  teams: (
    <>
      <rect width="100" height="100" rx="22" fill="#5059C9" />
      <line x1="32" y1="34" x2="68" y2="34" stroke="#fff" strokeWidth="10" strokeLinecap="round" />
      <line x1="50" y1="34" x2="50" y2="70" stroke="#fff" strokeWidth="10" strokeLinecap="round" />
    </>
  ),
  zoom: (
    <>
      <rect width="100" height="100" rx="24" fill="#0B5CFF" />
      <rect x="20" y="36" width="36" height="28" rx="9" fill="#fff" />
      <path d="M60 47 L80 36 V64 L60 53 Z" fill="#fff" />
    </>
  ),
  whatsapp: (
    <>
      <circle cx="50" cy="50" r="48" fill="#25D366" />
      <circle cx="50" cy="48" r="28" fill="#fff" />
      <path d="M28 84 L34 66 L46 76 Z" fill="#fff" />
      <path d="M41 36c-2 0-5 2-5 6 0 10 12 22 22 22 4 0 6-3 6-5l-1-3-8-4-3 3c-4-2-8-6-10-10l3-3-4-8z" fill="#25D366" />
    </>
  ),
  figma: (
    <>
      <path d="M50 16 H39.5 a11 11 0 0 0 0 22 H50 Z" fill="#F24E1E" />
      <path d="M50 16 H60.5 a11 11 0 0 1 0 22 H50 Z" fill="#FF7262" />
      <path d="M50 39 H39.5 a11 11 0 0 0 0 22 H50 Z" fill="#A259FF" />
      <circle cx="60.5" cy="50" r="11" fill="#1ABCFE" />
      <path d="M50 62 H39.5 a11 11 0 0 0 0 22 c6 0 10.5-5 10.5-11 Z" fill="#0ACF83" />
    </>
  ),
  notion: (
    <>
      <rect width="100" height="100" rx="22" fill="#fff" stroke="#E3E3E3" strokeWidth="2" />
      <path d="M34 70 V30 L66 70 V30" stroke="#191919" strokeWidth="9" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  github: (
    <>
      <circle cx="50" cy="50" r="48" fill="#24292F" />
      <circle cx="50" cy="52" r="20" fill="#fff" />
      <path d="M36 40 L31 27 L44 33 Z" fill="#fff" />
      <path d="M64 40 L69 27 L56 33 Z" fill="#fff" />
    </>
  ),
  discord: (
    <>
      <rect width="100" height="100" rx="24" fill="#5865F2" />
      <ellipse cx="50" cy="52" rx="25" ry="19" fill="#fff" />
      <ellipse cx="41" cy="52" rx="4.5" ry="5.5" fill="#5865F2" />
      <ellipse cx="59" cy="52" rx="4.5" ry="5.5" fill="#5865F2" />
    </>
  ),
  docker: (
    <>
      <rect width="100" height="100" rx="22" fill="#2496ED" />
      <g fill="#fff">
        <rect x="25" y="46" width="11" height="9" rx="1.5" />
        <rect x="38" y="46" width="11" height="9" rx="1.5" />
        <rect x="51" y="46" width="11" height="9" rx="1.5" />
        <rect x="38" y="35" width="11" height="9" rx="1.5" />
        <rect x="51" y="35" width="11" height="9" rx="1.5" />
        <rect x="64" y="46" width="11" height="9" rx="1.5" />
        <rect x="20" y="58" width="60" height="9" rx="4.5" />
      </g>
    </>
  ),
  mongodb: (
    <>
      <path d="M50 12 c10 16 16 28 16 40 0 14 -8 24 -14 28 l-2 8 -2-8 c-6-4-14-14-14-28 0-12 6-24 16-40 z" fill="#00A35C" />
      <path d="M50 12 c10 16 16 28 16 40 0 14 -8 24 -14 28 l-2 8 Z" fill="#00684A" opacity="0.9" />
    </>
  ),
  opera: (
    <>
      <ellipse cx="50" cy="50" rx="19" ry="27" fill="none" stroke="#FF1B2D" strokeWidth="13" />
    </>
  ),
  wps: (
    <>
      <rect width="100" height="100" rx="22" fill="#E23E31" />
      <polyline points="26,32 36,68 50,42 64,68 74,32" stroke="#fff" strokeWidth="8.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  firefox: (
    <>
      <circle cx="50" cy="50" r="46" fill="#FF7139" />
      <path d="M50 12c-16 0-28 11-30 24 5-6 12-9 19-8-9 5-15 14-15 25 0 15 12 27 27 27s27-12 27-27c0-8-3-14-8-19 3 8 2 14-2 18 3-16-6-30-18-40Z" fill="#FFBD4F" />
      <circle cx="50" cy="58" r="17" fill="#FF4F00" />
    </>
  ),
  postman: (
    <>
      <circle cx="50" cy="50" r="48" fill="#FF6C37" />
      <path d="M36 66 62 40l-8-8a14 14 0 0 0-20 20l8 8-10 10 4 4Z" fill="#fff" />
      <circle cx="58" cy="36" r="7" fill="#FF6C37" />
    </>
  ),
  s3: (
    <>
      <rect width="100" height="100" rx="22" fill="#232F3E" />
      <path d="M18 38 50 22l32 16v10L50 32 18 48V38Z" fill="#E8A317" />
      <path d="M18 48 50 32l32 16v36L50 68 18 84V48Z" fill="#F5B62A" />
      <path d="M50 32v36l32 16V48L50 32Z" fill="#C78814" />
    </>
  ),
  finder: (
    <>
      <rect width="100" height="100" rx="22" fill="#1D9BF6" />
      <path d="M50 16v52" stroke="#fff" strokeWidth="6" strokeLinecap="round" />
      <path d="M30 34c4 6 4 12 0 18M70 34c-4 6-4 12 0 18" stroke="#fff" strokeWidth="6" strokeLinecap="round" fill="none" />
      <path d="M28 78c14 6 30 6 44 0" stroke="#fff" strokeWidth="6" strokeLinecap="round" fill="none" />
    </>
  ),
  explorer: (
    <>
      <rect width="100" height="100" rx="20" fill="#FFC107" />
      <path d="M14 32h26l8 10h38a6 6 0 0 1 6 6v28a6 6 0 0 1-6 6H20a6 6 0 0 1-6-6Z" fill="#FFE082" />
      <path d="M14 40h72v36a6 6 0 0 1-6 6H20a6 6 0 0 1-6-6Z" fill="#FFA000" />
    </>
  ),
  sublime: (
    <>
      <rect width="100" height="100" rx="22" fill="#2B2B2B" />
      <path d="M74 24 30 38v14l44-14Z" fill="#FF9800" />
      <path d="M26 48l44 14-44 14Z" fill="#FF9800" opacity=".75" />
    </>
  ),
  dbeaver: (
    <>
      <rect width="100" height="100" rx="22" fill="#372923" />
      <ellipse cx="50" cy="34" rx="26" ry="10" fill="#C6A992" />
      <path d="M24 34v32c0 6 12 10 26 10s26-4 26-10V34" fill="none" stroke="#C6A992" strokeWidth="8" />
    </>
  ),
  pycharm: (
    <>
      <rect width="100" height="100" rx="22" fill="#21D789" />
      <path d="M0 0h100v100H0Z" fill="none" />
      <rect x="0" y="0" width="100" height="100" rx="22" fill="url(#pcg)" />
      <defs>
        <linearGradient id="pcg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#21D789" /><stop offset="100%" stopColor="#07C3F2" />
        </linearGradient>
      </defs>
      <path d="M20 74h26" stroke="#fff" strokeWidth="7" strokeLinecap="round" />
      <path d="M32 22h18a14 14 0 0 1 0 28H42v14H32Z" fill="#fff" />
    </>
  ),
  phpstorm: (
    <>
      <rect width="100" height="100" rx="22" fill="url(#psg)" />
      <defs>
        <linearGradient id="psg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#B345F1" /><stop offset="100%" stopColor="#FF318C" />
        </linearGradient>
      </defs>
      <path d="M20 74h26" stroke="#fff" strokeWidth="7" strokeLinecap="round" />
      <path d="M30 22h18a13 13 0 0 1 0 26h-8v12H30Z" fill="#fff" />
    </>
  ),
  acrobat: (
    <>
      <rect width="100" height="100" rx="22" fill="#B30B00" />
      <path d="M50 26c-6 0-8 6-6 13 3 11 12 26 20 33 5 4 9 2 9-2 0-5-8-8-19-9-13-1-27 3-33 9-3 3-1 7 3 7 7 0 15-14 20-27 3-9 4-24 6-24Z" fill="#fff" />
    </>
  ),
  anydesk: (
    <>
      <rect width="100" height="100" rx="22" fill="#EF443B" />
      <path d="M50 20 82 50 50 80 18 50Z" fill="#fff" />
      <path d="M50 36 66 50 50 64 34 50Z" fill="#EF443B" />
    </>
  ),
  calculator: (
    <>
      <rect width="100" height="100" rx="22" fill="#546E7A" />
      <rect x="20" y="18" width="60" height="20" rx="4" fill="#CFD8DC" />
      <g fill="#CFD8DC">
        <rect x="20" y="46" width="16" height="14" rx="3" /><rect x="42" y="46" width="16" height="14" rx="3" />
        <rect x="64" y="46" width="16" height="14" rx="3" /><rect x="20" y="66" width="16" height="14" rx="3" />
        <rect x="42" y="66" width="16" height="14" rx="3" />
      </g>
      <rect x="64" y="66" width="16" height="14" rx="3" fill="#FF7043" />
    </>
  ),
  electron: (
    <>
      <rect width="100" height="100" rx="22" fill="#2B2E3A" />
      <ellipse cx="50" cy="50" rx="42" ry="17" fill="none" stroke="#9FEAF9" strokeWidth="5" />
      <ellipse cx="50" cy="50" rx="42" ry="17" fill="none" stroke="#9FEAF9" strokeWidth="5" transform="rotate(60 50 50)" />
      <ellipse cx="50" cy="50" rx="42" ry="17" fill="none" stroke="#9FEAF9" strokeWidth="5" transform="rotate(120 50 50)" />
      <circle cx="50" cy="50" r="7" fill="#9FEAF9" />
    </>
  ),
  rdp: (
    <>
      <rect width="100" height="100" rx="22" fill="#0078D4" />
      <rect x="16" y="24" width="68" height="42" rx="5" fill="#fff" />
      <path d="M34 78h32" stroke="#fff" strokeWidth="7" strokeLinecap="round" />
      <path d="M42 46h20M54 38l8 8-8 8" fill="none" stroke="#0078D4" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  tally: (
    <>
      <rect width="100" height="100" rx="22" fill="#1A3E6E" />
      <path d="M24 30h52M50 30v46" stroke="#fff" strokeWidth="9" strokeLinecap="round" />
      <path d="M30 76h40" stroke="#F5A623" strokeWidth="9" strokeLinecap="round" />
    </>
  ),
  teamgrid: (
    <>
      <rect width="100" height="100" rx="22" fill="#FF584A" />
      <path d="M24 30h52" stroke="#fff" strokeWidth="9" strokeLinecap="round" />
      <path d="M50 30v44" stroke="#fff" strokeWidth="9" strokeLinecap="round" />
      <rect x="20" y="60" width="14" height="14" rx="3" fill="#fff" opacity=".75" />
      <rect x="66" y="60" width="14" height="14" rx="3" fill="#fff" opacity=".75" />
    </>
  ),
  gchat: (
    <>
      <rect width="100" height="100" rx="22" fill="#fff" />
      <path d="M18 26h64a6 6 0 0 1 6 6v32a6 6 0 0 1-6 6H46L28 84V70h-10a6 6 0 0 1-6-6V32a6 6 0 0 1 6-6Z" fill="#00AC47" />
      <circle cx="38" cy="48" r="5" fill="#fff" /><circle cx="52" cy="48" r="5" fill="#fff" /><circle cx="66" cy="48" r="5" fill="#fff" />
    </>
  ),
  mysql: (
    <>
      <rect width="100" height="100" rx="22" fill="#00618A" />
      <ellipse cx="50" cy="32" rx="26" ry="9" fill="#F29111" />
      <path d="M24 32v34c0 5 12 9 26 9s26-4 26-9V32" fill="none" stroke="#F29111" strokeWidth="8" />
    </>
  ),
  antigravity: (
    <>
      <rect width="100" height="100" rx="24" fill="#B86BFF" />
      <ellipse cx="50" cy="52" rx="32" ry="12" fill="none" stroke="#fff" strokeWidth="6" transform="rotate(-18 50 52)" />
      <circle cx="50" cy="44" r="12" fill="#fff" />
    </>
  ),
};

/* Most-specific key first — "google chrome" must win before "chrome",
   "command prompt" before generic fragments. Same substring contract as
   BRAND so colour-fallback and glyphs never disagree on identity. */
const ALIASES = [
  ["google chrome", "chrome"], ["chrome", "chrome"],
  ["microsoft edge", "edge"], ["msedge", "edge"], ["edge", "edge"],
  ["safari", "safari"],
  ["claude", "claude"],
  ["slack", "slack"],
  ["command prompt", "cmd"], ["cmd", "cmd"],
  ["powershell", "powershell"],
  ["iterm", "terminal"], ["terminal", "terminal"],
  ["notepad", "notepad"],
  ["notes", "notes"],
  ["visual studio code", "vscode"], ["vs code", "vscode"], ["vscode", "vscode"], ["code", "vscode"],
  ["cursor", "cursor"],
  ["excel", "excel"],
  ["powerpoint", "powerpoint"],
  ["word", "word"],
  ["outlook", "outlook"],
  ["gmail", "gmail"],
  ["msteams", "teams"], ["teams", "teams"],
  ["zoom", "zoom"],
  ["whatsapp", "whatsapp"],
  ["figma", "figma"],
  ["notion", "notion"],
  ["github", "github"],
  ["discord", "discord"],
  ["docker", "docker"],
  ["mongodb", "mongodb"], ["compass", "mongodb"],
  ["opera", "opera"],
  ["wps", "wps"],
  ["antigravity", "antigravity"],
  ["firefox", "firefox"], ["mozilla", "firefox"],
  ["postman", "postman"],
  ["amazon s3", "s3"], [" s3 ", "s3"],
  ["finder", "finder"],
  ["file explorer", "explorer"], ["windows explorer", "explorer"], ["explorer", "explorer"],
  ["sublime", "sublime"],
  ["dbeaver", "dbeaver"],
  ["pycharm", "pycharm"],
  ["phpstorm", "phpstorm"], ["webstorm", "phpstorm"], ["intellij", "phpstorm"], ["datagrip", "phpstorm"],
  ["acrobat", "acrobat"], ["adobe reader", "acrobat"],
  ["anydesk", "anydesk"],
  ["calculator", "calculator"],
  ["electron", "electron"],
  ["remote desktop", "rdp"], ["mstsc", "rdp"],
  ["tally", "tally"],
  ["team grid", "teamgrid"], ["teamgrid", "teamgrid"],
  ["google chat", "gchat"], ["gchat", "gchat"],
  ["mysql", "mysql"], ["workbench", "mysql"],
];

export function toolGlyphIdFor(name) {
  const n = String(name || "").toLowerCase();
  for (const [key, id] of ALIASES) if (n.includes(key)) return id;
  return null;
}

const WEAK_ALIAS = new Set(["code", "word", "notes", "cmd", "explorer"]);

/** First real app name inside a sentence — skips weak words ("code" in "encode"). */
export function toolNameInText(text) {
  const n = String(text || "").toLowerCase();
  for (const [key] of ALIASES) {
    if (key.length < 4 || WEAK_ALIAS.has(key)) continue;
    if (n.includes(key)) return key;
  }
  return null;
}

export function ToolGlyph({ id, size = 20 }) {
  const body = ICONS[id];
  if (!body) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true" style={{ display: "block" }}>
      {body}
    </svg>
  );
}
